import { LinkButtonWithIcon } from "@/components/Buttons/LinkButtonWithIcon"
import ConfidentialLines from "@/components/ConfidentialLines"
import FormattedEmail from "@/components/FormattedEmail"
import FormattedPhone from "@/components/FormattedPhone"
import { UserSquareIcon } from "@/components/Icons"
import { EyeIcon } from "@/components/Icons"
import { SheetField, SheetFieldGrid, SheetSection } from "@/components/Sections/SheetSection"
import { P3 } from "@/components/Typographies"
import { getDefaultContactDetails } from "@/domain/contactdetails/getContactDetails"
import { getDisplayedName } from "@/domain/people/getDisplayedName"
import { getPeopleLinkSheet } from "@/domain/people/getPeopleLinkSheet"
import type { SharedDataJsonldReadCollectionSharedDataPeople } from "@/networking/api"
import { isNotBlank } from "@/utils/ts-utils"
import { useIntl } from "react-intl"
import { useNavigate } from "react-router-dom"

type Props = {
  people: SharedDataJsonldReadCollectionSharedDataPeople
}

export const PeopleSection = ({ people }: Props) => {
  const intl = useIntl()
  const navigateTo = useNavigate()

  const contactDetails =
    getDefaultContactDetails(people?.contactDetails)?.contactDetails ?? undefined

  return (
    <SheetSection
      title={intl.formatMessage({ id: "userSharedData.people.details" })}
      icon={UserSquareIcon}
      isFirst
    >
      <SheetFieldGrid>
        <SheetField label={intl.formatMessage({ id: "userSharedData.people.name" })}>
          {getDisplayedName(people ?? undefined)}
          <LinkButtonWithIcon
            display="inline-block"
            ml="2"
            icon={EyeIcon}
            onClick={() => navigateTo(getPeopleLinkSheet(people))}
          />
        </SheetField>
        {people?.isShared ? (
          <SheetField label={intl.formatMessage({ id: "userSharedData.people.contactDetails" })}>
            {isNotBlank(contactDetails?.email) && (
              <P3 display="block">
                <FormattedEmail email={contactDetails?.email} />
              </P3>
            )}
            {isNotBlank(contactDetails?.phone) && (
              <P3 display="block">
                <FormattedPhone phone={contactDetails?.phone} />
              </P3>
            )}
            {isNotBlank(contactDetails?.phone2) && (
              <P3 display="block">
                <FormattedPhone phone={contactDetails?.phone2} />
              </P3>
            )}
            {isNotBlank(contactDetails?.mobile) && (
              <P3 display="block">
                <FormattedPhone phone={contactDetails?.mobile} />
              </P3>
            )}
          </SheetField>
        ) : (
          <SheetField label={intl.formatMessage({ id: "userSharedData.people.contactDetails" })}>
            <ConfidentialLines nbOfLines={2} />
          </SheetField>
        )}
      </SheetFieldGrid>
    </SheetSection>
  )
}
